import { render } from "./Tablist.vue?vue&type=template&id=2f8583b0&scoped=true"
import script from "./Tablist.vue?vue&type=script&lang=js"
export * from "./Tablist.vue?vue&type=script&lang=js"

import "./Tablist.vue?vue&type=style&index=0&id=2f8583b0&scoped=true&lang=css"

import exportComponent from "/Users/min/Desktop/lambda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8583b0"]])

export default __exports__